import React, { useState, useEffect } from "react";
import { Button, Form, Table, Row, Col } from "react-bootstrap";

import axios from "axios";

// Mock permission options for demonstration
const PERMISSION_OPTIONS = [
  "Search",
  "Free CMS",
  "About Us",
  "Advertise Us",
  "Parent Page",
  "Favorites",
  "Members",
  "Login",
  "My Profile",
  "Registration",
  "Blog",
  "Tag Management",
  "Blog Archive",
  "Blog Edit",
  "Blog Add",
  "Blog Remove",
];

// Simulate fetching roles
const fetchRoles = () => [
  {
    id: 1,
    name: "Admin",
    description: "Administrator",
    permissions: ["Manage Users", "Edit Content", "Configure Settings"],
  },
  {
    id: 2,
    name: "Author",
    description: "Content Author",
    permissions: ["Submit Articles", "Edit Own Articles"],
  },
  {
    id: 3,
    name: "Distributor",
    description: "Content Distributor",
    permissions: ["Distribute Articles", "Manage Distribution"],
  },
  {
    id: 4,
    name: "User",
    description: "Regular User",
    permissions: ["View Content"],
  },
];

const RoleManagement = () => {
  const [roles, setRoles] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [roleToEdit, setRoleToEdit] = useState(null);
  const [newRole, setNewRole] = useState({
    name: "",
    description: "",
    permissions: [],
  });

  useEffect(() => {
    setRoles(fetchRoles());
  }, []);

  const fetchData = async () => {

    try {
      const roleResponse = await axios.get("")

      if (roleResponse.data.message.success === true) {
        const responseData = roleResponse.data.message.data;
        setRoles(responseData);

        }
      
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAddRole = () => {
    const nextId = roles.length
      ? Math.max(roles.map((role) => role.id)) + 1
      : 1;
    setRoles([...roles, { ...newRole, id: nextId }]);
    setNewRole({ name: "", description: "", permissions: [] });
    setEditMode(false);
  };

  const handleEditRole = () => {
    setRoles(
      roles.map((role) =>
        role.id === roleToEdit.id ? { ...roleToEdit, ...newRole } : role
      )
    );
    setNewRole({ name: "", description: "", permissions: [] });
    setRoleToEdit(null);
    setEditMode(false);
  };

  const handleDeleteRole = (roleId) => {
    setRoles(roles.filter((role) => role.id !== roleId));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewRole({ ...newRole, [name]: value });
  };

  const handlePermissionsChange = (permission, value) => {
    setNewRole((prevRole) => {
      const updatedPermissions =
        value === "Yes"
          ? [...prevRole.permissions, permission]
          : prevRole.permissions.filter((perm) => perm !== permission);
      return {
        ...prevRole,
        permissions: updatedPermissions,
      };
    });
  };

  const startEditMode = (role) => {
    setRoleToEdit(role);
    setNewRole({
      name: role.name,
      description: role.description,
      permissions: role.permissions,
    });
    setEditMode(true);
  };

  const handleCancel = () => {
    setEditMode(false);
    setRoleToEdit(null);
    setNewRole({ name: "", description: "", permissions: [] });
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center admin-page-head">
        <h4 className="mb-1">Roles Management</h4>
        <Button
          className="btn btn-dark mb-3"
          onClick={() => {
            setEditMode(true);
            setRoleToEdit(null);
            setNewRole({ name: "", description: "", permissions: [] });
          }}
        >
          Add New Role
        </Button>
      </div>
      {!editMode ? (
        <div className="table-responsive">
          <Table striped bordered hover className="table-responsive-scroll">
            <thead className="thead-dark">
              <tr>
                <th>Role Name</th>
                <th>Description</th>
                <th>Permissions</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {roles.map((role) => (
                <tr key={role.id}>
                  <td>{role.name}</td>
                  <td>{role.description}</td>
                  <td>{role.permissions.join(", ")}</td>
                  <td>
                    <div className="actbtn-grp">
                      <Button
                        className="btn btn-outline-dark btn-sm "
                        onClick={() => startEditMode(role)}
                      >
                        <i class="fa-solid fa-pen-to-square"></i>
                      </Button>
                      <Button
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => handleDeleteRole(role.id)}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="bg-white p-3 mb-3">
          <h4>{roleToEdit ? "Edit Role" : "Add New Role"}</h4>
          <Form>
            <Form.Group controlId="formRoleName" className="mb-3">
              <Form.Label>Role Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter role name"
                name="name"
                value={newRole.name}
                onChange={handleInputChange}
              />
            </Form.Group>
            <Form.Group controlId="formRoleDescription" className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter description"
                name="description"
                value={newRole.description}
                onChange={handleInputChange}
              />
            </Form.Group>
            <Form.Group controlId="formRolePermissions" className="mb-3">
              <Form.Label>Permissions</Form.Label>
              <Row>
                {PERMISSION_OPTIONS.map((permission, index) => (
                  <Col
                    xs={12}
                    md={6}
                    key={permission}
                    className={`divider mb-2 ${index % 2 === 0 ? "pe-3" : ""}`}
                    style={{
                      borderRight: index % 2 === 0 ? "2px solid #ddd" : "none",
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <Form.Label
                        className="me-3 w-50"
                        style={{ cursor: "pointer" }}
                      >
                        {permission}
                      </Form.Label>
                      <Form.Check
                        type="radio"
                        id={`${permission}-yes`}
                        name={permission}
                        value="Yes"
                        label="Yes"
                        checked={newRole.permissions.includes(permission)}
                        onChange={() =>
                          handlePermissionsChange(permission, "Yes")
                        }
                        style={{ cursor: "pointer" }}
                        className="me-2"
                      />
                      <Form.Check
                        type="radio"
                        id={`${permission}-no`}
                        name={permission}
                        value="No"
                        label="No"
                        checked={!newRole.permissions.includes(permission)}
                        onChange={() =>
                          handlePermissionsChange(permission, "No")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </Col>
                ))}
              </Row>
            </Form.Group>
            <Button
              variant="dark"
              type="button"
              className="mt-3"
              onClick={roleToEdit ? handleEditRole : handleAddRole}
            >
              {roleToEdit ? "Update Role" : "Add Role"}
            </Button>
            <Button
              variant="outline-secondary"
              className="ms-2 mt-3"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Form>
        </div>
      )}
      <style jsx>
        {" "}
        {`
          .actbtn-grp {
            display: flex;
            gap: 6px;
            flex-wrap: wrap;
          }
        `}
      </style>
    </div>
  );
};

export default RoleManagement;
